import Vuex from "vuex";
import Vue from "vue";
import qs from "qs";
import { AUTH_TOKEN_URL } from "../http/base-urls";

Vue.use(Vuex);

const axios = require("axios");

const state = {
  token: null,
  protocolo: null
};

const mutations = {
  AUTENTICADO(state, { token }) {
    state.token = token;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  USUARIO_LOGADO(state, { protocolo }) {
    state.protocolo = protocolo
},
};
const actions = {
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  autenticar({ commit }) {
    return new Promise((resolve, reject) => {
      let config = {
        method: "GET",       
        url: AUTH_TOKEN_URL
      };

      axios(config)
        .then((response) => {
          const access_token = response.data.access_token;
          
          localStorage.setItem("token", access_token);

          commit("AUTENTICADO", { token: access_token });

          resolve(access_token);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const getters = {
  token: (state) => state.token,
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
});
